import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/SiteFooter/Footer.js";
import HeaderLinks from "components/SiteHeader/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
// Sections for this page
import Info from "./Sections/Info.js";
import Budget from "./Sections/Budget.js";
import NGOs from "./Sections/NGOs.js";
import Municipality from "./Sections/Municipality.js";
import Project from "./Sections/Project.js";
import Brand from "../Brand.js";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export const district_info = {
  title:"परिचय",
  name:"जि स स भक्तपुर",
  images:[{
      image_description: "भक्तपुर दरवार क्षेत्र"
    },{
      image_description: "भक्तपुर जिल्लाको नयाँ स्थानीय तह सहितको नक्सा"
  },{
      image_description: "भक्तपुर नगरपालिका"
    },{
      image_description: "भक्तपुर नगरपालिका"
  },{
      image_description: "चाँगुनारायण नगरपालिका"
  },{
      image_description: "मध्यपुर थिमि नगरपालिका"
    },{
      image_description: "मध्यपुर थिमि नगरपालिका"
  },{
      image_description: "सूर्यविनायक नगरपालिका"
  }]
}

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="primary"
        routes={dashboardRoutes}
        brand=<Brand />
        shrink_brand=<Brand shrink={true}/>
        rightLinks={<div><HeaderLinks /></div>}
        // fixed
        changeColorOnScroll={{
          // height: 70,
          // color: "primary",
        }}
        {...rest}
      />
      <div className={classNames(classes.main)}>
        <div className={classes.container} >
          <Info info={district_info} link="intro" homepage={true}/>
        </div>
        <div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <Municipality  page="intro" />
          </div>
        </div>
        <div className={classes.container} >
          <Budget />
        </div>
        <div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <Project />
          </div>
        </div>
        {/*<div className={classes.container} >
          <NGOs />
        </div>*/}
      </div>
      <Footer />
    </div>
  );
}
